import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "TaskZoneGroupDashboardPage" */
	'pages/intervention/TaskZoneGroup/TaskZoneGroupDashboardPage'));

export default [{ component, exact: true, path: '/task_zone_groups/:taskZoneGroupId' }];